import styled, { css } from 'styled-components'
import { TABLET_BREAKPOINT } from 'styles/breakpoints'

export const LoggedOutHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    padding-top: 0;
    padding-right: 16px;
  }
`

export const LoggedOutHeaderButtonRow = styled.div`
  display: flex;
  & > * + * {
    margin-left: 12px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    margin-right: 12px;
  }
`
